import { render, staticRenderFns } from "./AddLayoutModal.vue?vue&type=template&id=060a538d&scoped=true"
import script from "./AddLayoutModal.vue?vue&type=script&lang=ts"
export * from "./AddLayoutModal.vue?vue&type=script&lang=ts"
import style0 from "./AddLayoutModal.vue?vue&type=style&index=0&id=060a538d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a538d",
  null
  
)

export default component.exports